module.exports = __webpack_public_path__ + "img/block_closed_blue.eee4bac1.svg";